export default __webpack_public_path__ + "static/media/The Conqueror's Crown.dd4c6bcb.jpg";